import { render } from "./RedirectResult.vue?vue&type=template&id=2dd80ffc"
import script from "./RedirectResult.vue?vue&type=script&lang=js"
export * from "./RedirectResult.vue?vue&type=script&lang=js"
script.render = render

export default script